var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u9501\u5B9A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4F1A\\u6240\\u7BA1\\u7406",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6253\\u4F4D\\u7BA1\\u7406",
    transform: "translate(-1337.000000, -322.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u798F\\u5229\\u6A21\\u5757\\u5907\\u4EFD-3",
    transform: "translate(232.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E00\\u53F7\\u6253\\u4F4D\\u5907\\u4EFD-6",
    transform: "translate(966.400000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation/Dropdown/Light/Option",
    transform: "translate(125.800000, 46.009249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9501\\u5B9A",
    transform: "translate(13.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8333333,5.83376551 C12.2015232,5.83376551 12.5,6.13224234 12.5,6.50043217 L12.5,11.5837655 C12.5,11.9519553 12.2015232,12.2504322 11.8333333,12.2504322 L2.66666667,12.2504322 C2.29847683,12.2504322 2,11.9519553 2,11.5837655 L2,6.50043217 C2,6.13224234 2.29847683,5.83376551 2.66666667,5.83376551 L11.8333333,5.83376551 Z M7.22411211,1 C8.83492878,1 10.1407788,2.30583542 10.1407788,3.91666667 L10.1407788,5.81273588 L4.30744545,5.81273588 L4.30744545,3.91666667 C4.30744545,2.30583542 5.61329545,1 7.22411211,1 Z M7.25,8.16709884 L7.25,9.91709884",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    strokeOpacity: 0.85,
    stroke: "#000000",
    strokeLinejoin: "round"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.86537a8cbbe5f22654dc2563dc5d57ce.svg";
export { ForwardRef as ReactComponent };